export default {
  AccountBalance: {
    Title: 'Nhập số dư ban đầu',
    TabName: 'Số dư tài khoản',
    PlaceholderSearch: 'Nhập số tài khoản tìm kiếm',
    EnterBalance: 'Nhập số dư',
    DeleteBalance: 'Xóa số dư',
    GetBeginingBalance: 'Lấy số dư đầu năm',
    TextBeginingBalance: 'Lấy số dư bao gồm chứng từ chỉnh lý quyết toán',
  },
  BankAccountBalance: {
    Title: 'Số dư Tài khoản ngân hàng',
    TabName: 'Số dư TK ngân hàng',
    TooltipName: 'Số dư Tài khoản ngân hàng',
  },
  AccountingObjectBalance: {
    Title: 'Số dư theo đối tượng',
    TabName: 'Số dư theo đối tượng',
  },
  OPAccountBalanceDetail: {
    Title: 'Nhập chi tiết số dư ban đầu',
    TabName: 'Số dư TK ngân hàng',
    Group: 'Nhóm theo cột',
  },
  InventoryMaterial: {
    Title: 'Tồn kho vật tư',
    TabName: 'Tồn kho vật tư',
  },
  AnotherAccountBalance: {
    Title: 'Nhập số dư Tài khoản khác',
    TabName: 'Số dư tài khoản khác',
    ImportBalanceAdvanceBeginingPeriod: 'Nhập khẩu số dư tạm ứng đầu kỳ',
    ImportBalanceNoDetailMLNS: 'Nhập khẩu số dư không chi tiết theo MLNS',
  },
  BankAccountBalanceDetail: {
    Title: 'Nhập chi tiết số dư tài khoản ngân hàng',
    AccountNumber: 'Số tài khoản: ',
    Group: 'Nhóm',
  },
  BankAccountBalancePopup: {
    Title: 'Nhập số dư tài khoản ngân hàng',
  },
  AccountingObjectBalancePopup: {
    Title: 'Nhập số dư chi tiết theo đối tượng',
  },
  InventoryMaterialBalancePopup: {
    Title: 'Nhập số dư tồn kho vật tư',
  },
  AnotherAccountBalanceDetailPopup: {
    Title: 'Nhập số dư chi tiết tài khoản khác',
    PlaceholderSearch: 'Nhập số tài khoản tìm kiếm',
  },
  BalanceDetailPopup: {
    Title: 'Nhập chi tiết số dư',
    AccountNumber: 'Số tài khoản: ',
    DebitAmount: 'Dư nợ',
    CreditAmount: 'Dư có',
  },
  DataBeginingYearPopup: {
    Title: 'Lấy dữ liệu đầu năm',
    SelectAccountingData: 'Chọn dữ liệu kế toán',
    GetData: 'Lấy dữ liệu',
    PlaceholderSearch: 'Nhập số tài khoản tìm kiếm',
  },
  Text: {
    ToastSuccess: 'Xóa thành công',
    ToastErrorSuccess: 'Xóa không thành công',
    NoAccountBalance: 'Tài khoản tổng hợp không có nhập số dư đầu kỳ.',
    TitleError: 'Tài khoản tổng hợp',
  },
  TitleForm: {
    AccountingObjectBalance: 'Nhập số dư chi tiết theo đối tượng',
    OPAccountBalanceDetail: 'Nhập chi tiết số dư ban đầu',
    BankAccountBalance: 'Nhập chi tiết số dư Tài khoản ngân hàng',
    InventoryMaterial: 'Nhập số dư tồn kho vật tư',
    AnotherAccountBalance: 'Nhập số dư chi tiết tài khoản khác',
  },
  TitleHistore: {
    BankInfo: 'Số dư ban đầu tài khoản ngân hàng',
    Budget: 'Số dư ban đầu mục lục ngân sách',
    CCDC: 'Số dư ban đầu công cụ dụng cụ',
    Inventory: 'Số dư ban đầu tồn kho vật tư',
    Object: 'Số dư ban đầu đối tượng',
    Activity: 'Số dư ban đầu hoạt động tài chính',
    Fund: 'Số dư ban đầu quỹ tiền mặt',
    ActivityObject: 'Số dư ban đầu hoạt động tài chính và Đối tượng',
    BankInfoFund: 'Số dư ban đầu tài khoản ngân hàng và Quỹ tiền mặt',
    BankInfoBudget: 'Số dư ban đầu tài khoản ngân hàng và Mục lục ngân sách',
  },
};
